import axios, { Method, AxiosRequestHeaders, AxiosRequestTransformer, AxiosInstance } from 'axios';

type TInstanceApi = {
  apiKey?: string,
  headers?: AxiosRequestHeaders,
  method?: Method | string,
  transformRequest?: AxiosRequestTransformer | AxiosRequestTransformer[],
  params?: any,
  authToken?: string | null,
}


// API version prefix (e.g. "api/v1"). Change here if upgrading to v2 later.
export const API_VERSIONS = 'api/v1'

// Keep service domains centralized
export const API_SERVICE_DOMAINS = {
  admin: 'admin',
  unitTest: 'unit-test',
}

// Use single API URL for each environment (set at build time)
const API_AZINSIGHT_URL = process.env.REACT_APP_AZINSIGHT_API;

const apiHeaders = {
  "content-type": "application/json",
}

export const asinzenAdminApi = ({ headers, method, transformRequest, params, authToken }: TInstanceApi): AxiosInstance => {
  // Using httpOnly cookies for authentication
  // Token is stored in httpOnly cookie (admin-portal-token) set by backend
  // No need to read from localStorage or send in Authorization header

  const instance = axios.create({
    baseURL: API_AZINSIGHT_URL,
    headers: {
      ...apiHeaders,
      ...headers,
      // Only send Authorization header if explicitly provided via authToken param
      // Otherwise, rely on httpOnly cookie for authentication
      ...(authToken && { 'Authorization': `Bearer ${authToken}` }),
    },
    method,
    transformRequest,
    params,
    withCredentials: true, // Enable cookies (httpOnly cookie will be sent automatically)
  });
  return instance;
};